var React = require('react');

function Industrial (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Industrial"),React.createElement("g",{"id":"g1409","key":2},[React.createElement("path",{"id":"path1191-9-1","className":"cls-1","d":"M114,44,94,24H34L14,44V84H114Z","key":0}),React.createElement("path",{"id":"path1223","className":"cls-1","d":"M14,104H114","key":1})])]);
}

Industrial.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Industrial;

Industrial.default = Industrial;
